// PDF filename builders. The uploaded lecture-note PDF's filename encodes the
// lecture's classification — a contract with the content service. These mirror
// the legacy naming exactly, sourced from the new segment APIs.

// Add flow, normal lecture: ExamTypeName_CourseName_TopicName[_SubTopicName]
export const buildNormalLectureFileName = ({ examTypeName, courseName, topicName, subTopicName }) => {
    let name = examTypeName + "_" + courseName + "_" + topicName;
    if (subTopicName) {
        name += "_" + subTopicName;
    }
    return name;
};

// Add flow, mutual lecture: Title[_TopicName[_SubTopicName]]
export const buildMutualLectureFileName = ({ title, topicName, subTopicName }) => {
    let name = title;
    if (topicName) {
        name += "_" + topicName;
        if (subTopicName) {
            name += "_" + subTopicName;
        }
    }
    return name;
};

// Update flow. Legacy code compared ref objects to strings (always true), so the
// current form values always won — we replicate that outcome directly.
// General lectures (SubCourseTopicUniqueId == 0) use the editable Title/TopicName
// inputs; normal lectures use the record's TopicName and the "A / B" split of
// SubTopicName.
export const buildUpdateLectureFileName = ({ examTypeName, lecture, titleInput, topicInput, subTopicInput }) => {
    const hasSlash = lecture.SubTopicName && lecture.SubTopicName.includes("/");
    const selectedSubTopicName = hasSlash
        ? lecture.SubTopicName.split("/")[0].trim()
        : lecture.SubTopicName;
    const subCourseName = subTopicInput;

    if (lecture.SegmentTopicId == 0) {
        return (
            examTypeName +
            (titleInput ? "_" + titleInput : "") +
            (topicInput ? "_" + topicInput : "") +
            (subCourseName ? "_" + subCourseName : "")
        );
    }
    return (
        examTypeName +
        (lecture.TopicName ? "_" + lecture.TopicName : "") +
        (selectedSubTopicName ? "_" + selectedSubTopicName : "") +
        (subCourseName ? "_" + subCourseName : "")
    );
};

// Lookup for the update flow: lecture records store the exam type in
// ExamCategoryId; the display name now comes from the segments response.
export const examTypeNameForLecture = (segments, lecture) => {
    const match = (segments || []).find((s) => s.ExamTypeId == lecture.ExamCategoryId);
    return match ? match.ExamTypeName : "";
};
